/* tslint:disable */

declare var Object: any;
export interface DiscountLimitInterface {
  "productType": string;
  "value": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "id"?: number;
}

export class DiscountLimit implements DiscountLimitInterface {
  "productType": string;
  "value": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "id": number;
  constructor(data?: DiscountLimitInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DiscountLimit`.
   */
  public static getModelName() {
    return "DiscountLimit";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DiscountLimit for dynamic purposes.
  **/
  public static factory(data: DiscountLimitInterface): DiscountLimit{
    return new DiscountLimit(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DiscountLimit',
      plural: 'DiscountLimits',
      path: 'DiscountLimits',
      idName: 'id',
      properties: {
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
